import { render } from "./CardUserPlan.vue?vue&type=template&id=831b92a8"
import script from "./CardUserPlan.vue?vue&type=script&lang=js"
export * from "./CardUserPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__